<!-- Content -->
<medsurf-slider *ngIf="(trainingViewerFacade.isTraining$ | async) === false"></medsurf-slider>
<medsurf-training-slider *ngIf="(trainingViewerFacade.isTraining$ | async) === true"></medsurf-training-slider>




